"use strict";require("__next_polyfill__fetch");Object.assign=require('__next_polyfill__object_assign');